module.exports = "/_next/static/images/4187b997d998274106fb6d8453c0a28d-double-card@sm-1x.png";